

class Message {

    constructor(data) {
        const { subject, screen_name, message, request_type, image, email } = data

        this.subject = subject
        this.message = message
        this.screen_name = screen_name
        this.email = email
        this.request_type = request_type.id || request_type
        if (image?.file)
            this.image = image.file
    }
}

export default Message